export default __webpack_public_path__ + "static/media/icon_close_24_Light_grey.b7104dc4.svg";